import * as Yup from 'yup';
import {
    stringLength,
    validateOptionalNumber,
} from "@/Shared/Helpers";


/**
 * =====================================================
 * Type: BirthWishFormValues
 * =====================================================
 *
 * Description:
 * Represents the form values for creating or editing a birthday wish.
 *
 * Properties:
 * - id: optional identifier of the birthday wish
 * - contactId: required identifier of the contact
 * - message: the birthday message content (10–500 characters)
 * - valid: boolean confirmation that the message is validated
 */
export type BirthWishFormValues = {
    id: number;
    contactId: number;
    message: string;
    valid: boolean;
};

/**
 * =====================================================
 * Function: BirthWishValidationSchema
 * =====================================================
 *
 * Description:
 * Returns a Yup validation schema for the `BirthWishFormValues`.
 *
 * Responsibilities:
 * - Ensures `id` is a valid optional number
 * - Requires a `contactId` to link the wish to a contact
 * - Validates `message` length between 10 and 500 characters
 * - Requires `valid` checkbox to be checked to confirm message validation
 *
 * Notes:
 * - Uses helper functions for optional number validation and string length
 * - Validation messages are in French (can be localized)
 */
export const BirthWishValidationSchema = () =>
    Yup.object({
        id: validateOptionalNumber(),

        contactId: validateOptionalNumber().required('Le contact est requis.'),

        message: stringLength({ minLength: 10, maxLength: 500 })
            .required('Le message est requis.'),

        /** Confirmation checkbox to validate the message */
        valid: Yup.boolean()
            .oneOf([true], 'Vous devez confirmer la validation du message.')
            .required('La confirmation est requise.')

    });
